import cn from 'classnames';

import MeetingCard from '../MeetingCard';
import OEmptyStatus from '@src/shared/OStatus';

import EmptyDataFound from '@src/assets/icons/EmptyDataFound';

import { TDateTab } from '../../scheduledMeetingsView.types';
import { IScheduledMeeting, TToggleView } from '@src/types';

import styles from './meetingList.module.scss';
import { useMediaQuery } from '@mui/material';

interface IMeetingListProps {
  isLoading: boolean;
  selectedTab: TDateTab;
  view: TToggleView;
  groupedMeetings: Record<string, IScheduledMeeting[]>;
  filteredMeetings: IScheduledMeeting[];
  selectedMeeting?: IScheduledMeeting | null;
  isModalOpen: boolean;
  onInvite?: (meeting: IScheduledMeeting, link?: string) => void;
}

const MeetingList = ({
  isLoading,
  selectedTab,
  view,
  groupedMeetings,
  filteredMeetings,
  selectedMeeting,
  isModalOpen,
  onInvite,
}: IMeetingListProps) => {
  const isMobileDevice = useMediaQuery('(max-width: 768px)');
  if (isLoading) {
    return <div className={styles.loadingMessage}>Loading meetings...</div>;
  }

  if (!filteredMeetings || filteredMeetings.length === 0) {
    return (
      <OEmptyStatus
        className={styles.emptyStatus}
        image={<EmptyDataFound />}
        title={`No Events Found`}
        subDescription="No events found for the selected period"
      />
    );
  }

  return (
    <div
      className={cn(
        ['later', 'customDate'].includes(selectedTab) ? styles.group : styles.scheduledView,
        styles[`${isMobileDevice ? 'list' : view}ViewContainer`]
      )}
    >
      {['later', 'customDate'].includes(selectedTab)
        ? Object.entries(groupedMeetings).map(([date, meetings]) => (
            <div key={date} className={styles.groupSection}>
              <h3 className={styles.groupDate}>{date}</h3>
              <div className={styles[`groupItems${view}`]}>
                {meetings.map((meeting) => (
                  <MeetingCard
                    key={meeting.id}
                    view={view}
                    meeting={meeting}
                    isActive={selectedMeeting?.id === meeting.id && isModalOpen}
                    onInvite={(link: string) => onInvite?.(meeting, link)}
                  />
                ))}
              </div>
            </div>
          ))
        : filteredMeetings.map((meeting) => (
            <MeetingCard
              key={meeting.id}
              view={view}
              meeting={meeting}
              isActive={selectedMeeting?.id === meeting.id && isModalOpen}
              onInvite={(link: string) => {
                onInvite?.(meeting, link);
              }}
            />
          ))}
    </div>
  );
};

export default MeetingList;
